import type { FunctionComponent } from "react";

import { Container, Duration, DurationContainer, Icon } from "./styles";

type Props = {
  duration: string;
};

export const HomepageVideoDurationOverlay: FunctionComponent<Props> = ({ duration }) => (
  <Container>
    <Icon />
    <DurationContainer>
      <Duration>{duration}</Duration>
    </DurationContainer>
  </Container>
);
